import AxiosInstance from "./api";

export const CashAdvanceRequestService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/cash-advance-request", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/cash-advance-request/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/cash-advance-request", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/cash-advance-request/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/cash-advance-request/${id}`);
  },
};
